import React, {useEffect, useState} from "react";
import MenuItem from "../../atoms/menu/menuItem";
import {IconSource} from "../../../shared/enums/iconSource";
import {Navigation} from "../../../utils/navigation";
import {RoutePaths} from "../../../shared/routePaths";
import {QueryParams} from "../../../shared/enums/queryParams";
import AccordionGroup from "../../molecules/accordionGroup/accordionGroup";
import {eventsRoute} from "../../../routes";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router";
import {VillageCalendar} from "../../../shared/interfaces/villageCalendar";
import "./navbarCalendarsMenu.sass";

export interface NavbarCalendarsMenuProps {
  calendars?: VillageCalendar[];
  initialIsExpanded: boolean;
  selectedCalendar: any;
}
const NavbarCalendarsMenu: React.FC<NavbarCalendarsMenuProps> = ({
  calendars = [],
  initialIsExpanded,
  selectedCalendar
}) => {
  const {t} = useTranslation(["translation"]);
  const history = useHistory();
  const [isExpanded, setIsExpanded] = useState(initialIsExpanded);

  useEffect(() => {
    setIsExpanded(initialIsExpanded);
  }, [initialIsExpanded]);

  const calendarsName = t("translation:titles.calendars");
  // Parent highlight tracks the active page, not the accordion open/closed state.
  const isParentSelected = initialIsExpanded;
  const children = calendars.map(({id, personType, name, calendarType}) => {
    const isSelected = initialIsExpanded && selectedCalendar === name;
    return (
      <MenuItem
        key={id ?? `${personType}-${name}`}
        title={name}
        testId="calendar-menu-item"
        icon={
          calendarType === "Enhanced"
            ? IconSource.featured
            : IconSource.favourite
        }
        selected={isSelected}
        scoped={isSelected}
        onClick={() => {
          Navigation.navigateWithParams(
            history,
            RoutePaths.Events,
            QueryParams.calendar,
            encodeURI(name),
            [
              QueryParams.type,
              QueryParams.EditSeries,
              QueryParams.Tab,
              QueryParams.TemplateId,
              QueryParams.OccurrenceDate
            ]
          );
        }}
      />
    );
  });

  return (
    <div className="navbar-calendar-menu">
      <AccordionGroup
        accordions={[
          {
            id: "calendars",
            header: () => (
              <MenuItem
                title={calendarsName}
                icon={eventsRoute.icon}
                selected={isParentSelected}
                scoped={isParentSelected}
              />
            ),
            children,
            toggleIcon: IconSource.toggleUp,
            toggleIconColor: isExpanded ? "primary" : "secondary",
            isExpanded: isExpanded,
            onAccordionClick: (_, isExpanded) => {
              setIsExpanded(isExpanded);
            }
          }
        ]}
      />
    </div>
  );
};

export default NavbarCalendarsMenu;
